export default __webpack_public_path__ + "static/media/all (1).562bac83.jpg";